import React, { Component } from 'react';
import PropTypes from 'prop-types';
import SelectWrapper from './ItemSelector.style';

class ItemSelector extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: '-1',
    };
    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(evt) {
    const { selectItem, items, id } = this.props;
    const { value } = evt.target;
    const item  = items[value];
    this.setState({ value }, () => {
      selectItem(id, item.name);
    });
  }

  render() {
    return (
      <div className="ncss-select">
        <div className="g72-arrow-thick-down text-color-black
        d-sm-b pt3-sm pb3-sm pt2-lg pr4-sm pb2-lg pl4-sm ta-sm-r"
        />
        <SelectWrapper aria-label="Select a Maxim" value={this.state.value} onChange={this.handleChange}>
          <option value="-1" disabled>
            {this.props.placeholder}
          </option>
          {this.props.items.map((item, index) => (
            <option key={item.id} value={index}>
              {item.name}
            </option>
            ))}
        </SelectWrapper>
      </div>
    );
  }
}

ItemSelector.propTypes = {
  selectItem: PropTypes.func.isRequired,
  items: PropTypes.arrayOf(PropTypes.object).isRequired,
  placeholder: PropTypes.string,
  id: PropTypes.string,
};

ItemSelector.defaultProps = {
  placeholder: '',
};

export default ItemSelector;



// WEBPACK FOOTER //
// ./src/components/ItemSelector/ItemSelector.js